export default {
  NightlyCountPage: {
    nightlyCount: 'Nightly Count',
  },
  NightlyCountPageTabs: {
    enterCount: 'Enter Count',
    countHistory: 'Count History',
  },
  EnterNightlyCountForm: {
    office: 'Office',
    submitCount: 'Submit Count',
    saveEdit: 'Save Edit',
    todaysCountExists:
      "Today's count already exists. You are editing the existing count.",
    noProductsConfigured:
      'No products configured. Ask an admin to set up products under Settings → Nightly Counts.',
    notAllowed: 'You are not allowed to enter counts for any office.',
    selectOffice: 'Select an office',
    enterCountForOffice: 'Enter nightly count',
    saveSuccess: 'Nightly count saved',
    saveError: 'Failed to save nightly count',
  },
  NightlyCountHistoryTable: {
    date: 'Date',
    office: 'Office',
    createdBy: 'Created by',
    edited: 'Edited',
    items: 'Items',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    resend: 'Resend',
    deleteConfirm: 'Delete this nightly count? This cannot be undone.',
    deleteSuccess: 'Nightly count deleted',
    resendSuccess: 'Notification resent',
    resendError: 'Failed to resend notification',
    deleteError: 'Failed to delete nightly count',
    countCount: '{{count}} items',
  },
  NightlyInventoryCountSettings: {
    title: 'Nightly Counts',
    products: 'Products',
    addProduct: 'Add Product',
    users: 'Users',
    notifications: 'Notifications',
    productClass: 'Class',
    productBloodType: 'Type',
    productTitle: 'Product',
    wcPid: 'WC PID',
    office: 'Office',
    count: 'Count',
    region: 'Region',
    template: 'Notification template',
    templateHelp:
      'Available variables: {{date}}, {{userName}}, {{userEmail}}, {{officeName}}, {{productCountList}}',
    emailRecipients: 'Email recipients',
    textRecipients: 'Text recipients (not yet wired)',
    teamsRecipients: 'Teams recipients (not yet wired)',
    allOffices: 'ALL offices',
    save: 'Save',
    settingsSaved: 'Settings saved',
    saveFailed: 'Failed to save settings',
    classPRBC: 'PRBC',
    classFFP: 'FFP',
    classWhole: 'Whole',
    classAccessory: 'Accessory',
    bloodTypePositive: 'Positive',
    bloodTypeNegative: 'Negative',
    selectClass: 'Select class',
    selectBloodType: 'Select blood type',
    selectOffice: 'Select office',
    requiredField: 'Required',
  },
  Navigation: {
    nightlyCount: 'Nightly Count',
  },
};
